module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top",
    class: _vm.siteName
  }, [_c('span', {
    staticClass: "ic"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adc426e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/top/top.vue
// module id = 632
// module chunks = 27